import { render } from "./ErrorPopup.vue?vue&type=template&id=60aedf05&scoped=true&ts=true"
import script from "./ErrorPopup.vue?vue&type=script&lang=ts"
export * from "./ErrorPopup.vue?vue&type=script&lang=ts"

import "./ErrorPopup.vue?vue&type=style&index=0&id=60aedf05&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\mobileApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60aedf05"]])

export default __exports__